export const useGetHTMLforPDFDownload = (ref: React.RefObject<HTMLDivElement>): { generate: () => string } => {
  const generate = (): string => {
    if (ref.current) {
      const node = ref.current
      const cloneNode = node.cloneNode(true) as HTMLElement
      document.body.appendChild(cloneNode)
      const elements = cloneNode.querySelectorAll("*")

      elements.forEach(element => {
        const computedStyle = getComputedStyle(element)
        const inlineStyle = Array.from(computedStyle).reduce((styleString, property) => {
          return `${styleString}${property}:${computedStyle.getPropertyValue(property)};`
        }, "")
        element.setAttribute("style", inlineStyle)
      })
      document.body.removeChild(cloneNode)

      const html = cloneNode.outerHTML
      return html
    }
    return ""
  }

  return { generate }
}
